<template>
  <modal
    size="lg"
    ref="modalComponent"
    :show="show"
    @hidden="$emit('input', false)"
    :scrollable="false"
    :hide-footer="true"
    title="Get inspiraton from these check-in templates"
  >
    <div class="container">
      <div>
        <div class="d-flex justify-content-between">
          <div class="text-normal-1 bold">Check-in Summary</div>
          <b-button variant="link" @click="useTemplate">Use this template</b-button>
        </div>
      </div>
      <div class="content" v-html="template"></div>
    </div>
    <confirm-dialog
      ref="confirmModal"
      title="Use Template?"
      @ok="selectTemplate"
      ok-title="Yes, Replace"
      cancel-title="No"
    >
      Using the template will replace the current note
    </confirm-dialog>
  </modal>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'
import updateEditorHTML from '@/utils/updateEditorHTML'
import { BButton } from 'bootstrap-vue'
import Modal from '@/components/Modal'
import { CHECKIN_TEMPLATE } from '@/constants/kr'

/**
 * This display a checkin template. User select the template to use it while making a checkin
 *
  @emits
 * - select-template
 */
export default {
  name: 'CheckinTemplates',
  props: ['show', 'entity', 'warnOnSelection'],
  model: {
    prop: 'show'
  },
  components: {
    BButton,
    Modal,
    ConfirmDialog
  },
  data() {
    return {
      template: updateEditorHTML(CHECKIN_TEMPLATE)
    }
  },
  methods: {
    selectTemplate() {
      this.$emit('select-template', CHECKIN_TEMPLATE)
      this.$refs.modalComponent.hide()
    },
    useTemplate() {
      if (this.warnOnSelection) {
        this.$refs.confirmModal.show()
      } else {
        this.selectTemplate()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.container {
  background-color: $selectionColor;
  border-radius: 10px;
  padding: 16px;
}

.content {
  border: 1px solid $borderTertiary;
  border-radius: 10px;
  background-color: $documentColor;
  padding: 12px;
}
</style>
